var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import DashboardComponent from "../Presentational/Dashboard/DashboardComponent";
import DashboardService from "../../Services/Dashboard.service";
import SEO from "../UI/SEO/SEO";
const DashboardContainer = () => {
    // State
    const [dashboard, setDashboard] = React.useState(null);
    const [widgets, setWidgets] = React.useState(null);
    const fetchData = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const dashboardWidgets = yield DashboardService.getDashboardWidgets();
        const defaultDashboard = yield DashboardService.getDefaultDashboard();
        setDashboard(defaultDashboard);
        setWidgets(dashboardWidgets);
    }), []);
    function onDashboardChanged() {
        fetchData();
    }
    // Initialize
    React.useEffect(() => {
        fetchData();
    }, [fetchData]);
    return (_jsxs("div", { className: "fullMinHeightMinusPrimaryNav bg-light", children: [_jsx(SEO, { title: "Home" }), _jsx(DashboardComponent, { dashboard: dashboard, onDashboardChanged: onDashboardChanged, widgets: widgets })] }));
};
export default DashboardContainer;
